import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { login, loginFailure, loginSuccess, logout, logoutFailure, logoutSuccess, register, registerSuccess } from './authentication.actions';
import { Router } from '@angular/router';
import { IAppState } from '../../app/app.reducer';
import { Store } from '@ngrx/store';
import { loadAppConfiguration, loadBrandingConfiguration } from '../app-configuration/app-configuration.actions';

@Injectable()
export class AuthenticationEffects {
  constructor(
    private actions$: Actions,
    private authService: AuthenticationService,
    private router: Router,
    private store$: Store<IAppState>
  ) { }

  login$ = createEffect(() =>
    this.actions$.pipe(
      ofType(login),
      switchMap((action) =>
        this.authService.login(action.userName, action.password).pipe(
          switchMap(() => [loginSuccess(), loadBrandingConfiguration(), loadAppConfiguration()]),
          tap(() => this.router.navigate([''])),
          catchError((error) => of(loginFailure({ error: error.error })))
        )
      ),
    )
  );

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(logout),
      switchMap(() =>
        this.authService.logout().pipe(
          map(() => logoutSuccess()),
          tap(() => this.router.navigate(['/login'])),
          catchError((error) => of(logoutFailure({ error: error.message })))
        )
      )
    )
  );

  register$ = createEffect(() =>
    this.actions$.pipe(
      ofType(register),
      switchMap((action) =>
        this.authService.register(action.userName, action.email, action.password, action.confirmPassword).pipe(
          map(() => registerSuccess({ user: action })),
          tap(() => this.router.navigate([''])),
          catchError((error) => of(loginFailure({ error: error.message })))
        )
      )
    )
  );
}
